import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';

@Injectable({
    providedIn: 'root'
})
export class VisitorPsychoEntryService extends ApiService {
    getByVisitors(data: any) {
        return super.post('/visitors-psycho-entry/visitors', data);
    }

    getDatesByVisitor(data: any) {
        return super.post('/visitors-psycho-entry/visitors/dates', data);
    }

    getCountDayAndFuture(id: number) {
        return super.get("/visitors-psycho-entry/count/day-future/" + id);
    }

    create(data: any) {
        return super.post('/visitors-psycho-entry/create', data);
    }

    update(data: any) {
        return super.put('/visitors-psycho-entry/update', data);
    }

    delete(id: number) {
        return super.delete('/visitors-psycho-entry/' + id);
    }
}
